import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Img1 from '../Fitnessimg/feature-1.jpg'; // Reusing as content samples
import Img2 from '../Fitnessimg/feature-2.jpg';
import Img3 from '../Fitnessimg/feature-3.jpg';
import Img4 from '../Fitnessimg/feature-4.jpg';
import PdfIcon from '../Fitnessimg/icon-1.png'; // For media kit

const Feature = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        nextArrow: <SampleNextArrow />, 
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    const contentSamples = [
        { 
            img: Img1, 
            title: "Nike Campaign", 
            type: "Sponsored Post",
            link: "https://instagram.com/p/nike-campaign",
            stats: "2.4M impressions, 18% engagement"
        },
        { 
            img: Img2, 
            title: "Gymshark Review", 
            type: "Product Video",
            link: "https://youtube.com/watch?v=gymshark-review",
            stats: "350K views, 12% CTR"
        },
        { 
            img: Img3, 
            title: "Fitness Challenge", 
            type: "Story Series",
            link: "https://instagram.com/stories/fitness-challenge",
            stats: "1.2M reaches, 5K shares"
        },
        { 
            img: Img4, 
            title: "MyProtein Unboxing", 
            type: "Reel Content",
            link: "https://instagram.com/reel/myprotein-unboxing",
            stats: "850K plays, 25K saves"
        }
    ];

    return (
        <div className="container-fluid feature bg-light py-5">
            <div className="container py-5">
                <div className="text-center mx-auto pb-5" style={{ maxWidth: "800px" }}>
                    <h4 className="text-primary">Content Portfolio</h4>
                    <h1 className="display-4 mb-4">Our Content Samples</h1>
                    <p>Explore our best performing content and campaign examples below. Click through to see full case studies and metrics.</p>
                </div>
                
                <Slider {...settings}>
                    {contentSamples.map((sample, index) => (
                        <div key={index} className="feature-item px-3 mt-4" style={{ width: "90%" }}>
                            <div className="feature-img">
                                <img src={sample.img} className="img-fluid w-100" alt="content sample" />
                                <div className="content-badge bg-primary">{sample.type}</div>
                            </div>
                            <div className="feature-content p-4 text-center">
                                <h4 className="mb-2">{sample.title}</h4>
                                <p className="text-muted mb-3">{sample.stats}</p>
                                <a href={sample.link} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-sm me-2">
                                    View Content
                                </a>
                                <a href={`#${sample.title.toLowerCase().replace(' ', '-')}-case`} className="btn btn-outline-primary btn-sm">
                                    Case Study
                                </a>
                            </div>
                        </div>
                    ))}
                </Slider>

                {/* Additional Resources Section */}
                <div className="row mt-5 pt-4">
                    <div className="col-md-4 mb-4">
                        <div className="resource-card p-4 h-100 bg-white rounded">
                            <div className="d-flex align-items-center mb-3">
                                <img src={PdfIcon} alt="PDF" className="me-3" style={{width: "40px"}} />
                                <h5 className="mb-0">Media Kit</h5>
                            </div>
                            <p className="mb-4">Download our complete media kit with audience demographics, rates, and collaboration options.</p>
                            <a href="/media-kit.pdf" download className="btn btn-primary w-100">
                                Download PDF
                            </a>
                        </div>
                    </div>
                    
                    <div className="col-md-4 mb-4">
                        <div className="resource-card p-4 h-100 bg-white rounded">
                            <div className="d-flex align-items-center mb-3">
                                <i className="fas fa-trophy text-primary me-3 fa-2x"></i>
                                <h5 className="mb-0">Past Campaigns</h5>
                            </div>
                            <p className="mb-4">Explore our most successful brand collaborations and their performance metrics.</p>
                            <a href="#campaigns" className="btn btn-primary w-100">
                                View Campaigns
                            </a>
                        </div>
                    </div>
                    
                    <div className="col-md-4 mb-4">
                        <div className="resource-card p-4 h-100 bg-white rounded">
                            <div className="d-flex align-items-center mb-3">
                                <i className="fas fa-video text-primary me-3 fa-2x"></i>
                                <h5 className="mb-0">Content Portfolio</h5>
                            </div>
                            <p className="mb-4">Browse our complete content archive showcasing different styles and formats.</p>
                            <a href="#portfolio" className="btn btn-primary w-100">
                                View Portfolio
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const SampleNextArrow = (props) => {
    const { onClick } = props;
    return (
        <div
            className="slick-arrow slick-next"
            style={{ right: "15px", zIndex: 10 }}
            onClick={onClick}
        />
    );
};

const SamplePrevArrow = (props) => {
    const { onClick } = props;
    return (
        <div
            className="slick-arrow slick-prev"
            style={{ left: "15px", zIndex: 10 }}
            onClick={onClick}
        />
    );
};

export default Feature;